import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { startLoader, stopLoader } from "../util/loader"
import { getFranchiseWebLocationIdDetails, commonStates, storeBookingApiPayload, getBrandDetailsFromBrandJson } from "../util/share";
import { getBrandJSON } from "../util/locationBasedBrandJson";
import { gtmCustomEventLeadFlow } from "../util/gtm-custom-event-lead-flow";
import { DomainIdentifier } from "../util/domainService";
import { LocalizationIdentifier } from "../util/localizationService";
import { disclaimerHandleCheck, DisclaimerServiceIdentifier } from "../util/disclaimerService";
import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { ContactUsPayloadModel } from "../apiCaching/POST-Requests/interface/contact/contactInterface";
import { requestEstimate } from "../util/requestEstimate";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { handleFilePreview, handleHideError } from "../apiCaching/POST-Requests/helperModules/handleBookingSubmit";

const FilesUrl = [null, null, null]
export class FormHandler {
    private form: HTMLFormElement | null = null;
    private mobileNumberInput: HTMLInputElement | null = null;
    private franchiseWebLocationId: any = '';
    private isLocalized: boolean = false;
    private readonly shortFormService: NodeListOf<HTMLElement>;
    private noteWithRequestBody: any;

    constructor(states: any) {
        this.init(states);
        this.clearFields()
        this.shortFormService = document.querySelectorAll('[id*="short-form-service-reminder"]');
        const radioElement = document.getElementById('inline-2-radio-6') as HTMLInputElement;
        if (radioElement)
            radioElement.checked = true;

        const contPhoneMethod = document.getElementById('inline-radio-3') as HTMLInputElement;

        if (contPhoneMethod)
            contPhoneMethod.checked = false;

        const receiveUpdateRadioEle = document.getElementById('inline-2-radio-8') as HTMLInputElement;
        if (receiveUpdateRadioEle) {
            receiveUpdateRadioEle.checked = true;
        }

    }

    clearFields = () => {
        // Get references to the input elements
        this.handleFocusOut = this.handleFocusOut.bind(this);
        const parentElement = document.querySelector('.contact-info form') as HTMLFormElement;
        const firstNameInput = parentElement?.querySelector('#send-name') as HTMLInputElement;
        const lastNameInput = parentElement?.querySelector('#send-lname') as HTMLInputElement;
        const zipCodeInput = parentElement?.querySelector('#send-zip') as HTMLInputElement;
        const emailInput = parentElement?.querySelector('#send-email') as HTMLInputElement;
        const address1Input = parentElement?.querySelector('#send-address1') as HTMLInputElement;
        const address2Input = parentElement?.querySelector('#send-address2') as HTMLInputElement;
        const cityInput = parentElement?.querySelector('#send-city') as HTMLInputElement;
        const stateSelect = parentElement?.querySelector('#send-state') as HTMLSelectElement;
        const noteTextarea = parentElement?.querySelector('#send-note') as HTMLTextAreaElement;

        const customerRadio = parentElement?.querySelector('#inline-radio-1') as HTMLInputElement;
        const customerRadio2 = parentElement?.querySelector('#inline-radio-2') as HTMLInputElement;

        const contPhoneMethod = parentElement?.querySelector('#inline-radio-3') as HTMLInputElement;
        const contEmailMethod = parentElement?.querySelector('#inline-radio-4') as HTMLInputElement;
        const contTextMethod = parentElement?.querySelector('#inline-radio-5') as HTMLInputElement;
        const signupRadioButton = parentElement?.querySelector('#inline-2-radio-3') as HTMLInputElement;
        const noThanksRadioButton = parentElement?.querySelector('#inline-2-radio-4') as HTMLInputElement;

        // Add event listeners to the input elements
        firstNameInput?.addEventListener('input', () => {

            if (firstNameInput.value !== '' && !REGEX.sendName.test(firstNameInput.value)) {
                const fieldError = document.getElementById(`${firstNameInput?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    firstNameInput.classList?.add('invalid-field');
                } else {
                    this.createErrorElement(firstNameInput, 'Enter a valid first name.');
                }
            } else {
                this.hideError(`${firstNameInput?.id}`);
            }

        });
        lastNameInput?.addEventListener('input', () => {

            if (lastNameInput.value !== '' && !REGEX.sendName.test(lastNameInput.value)) {

                const fieldError: any = document.getElementById(`${lastNameInput?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    lastNameInput.classList?.add('invalid-field');

                }
                else {
                    this.createErrorElement(lastNameInput, 'Enter a valid last name.');
                }
            }
            else {
                this.hideError('send-lname')
            }


        });
        zipCodeInput?.addEventListener('input', () => {

            if (zipCodeInput.value !== '' && !REGEX.sendZip.test(zipCodeInput.value)) {
                const fieldError = document.getElementById(`${zipCodeInput?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    zipCodeInput.classList?.add('invalid-field');
                } else {
                    this.createErrorElement(zipCodeInput, 'Enter a valid zip code.');
                }
            } else {
                this.hideError(`${zipCodeInput?.id}`);
            }

        });
    
        emailInput?.addEventListener('input', () => {

            if (emailInput.value !== '' && !REGEX.sendEmail.test(emailInput.value)) {
                const fieldError = document.getElementById(`${emailInput?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    emailInput.classList?.add('invalid-field');
                } else {
                    this.createErrorElement(emailInput, 'Enter a valid email address.');
                }
            } else {
                this.hideError(`${emailInput?.id}`);
            }

        });
        address1Input?.addEventListener('input', () => {

            if (address1Input.value !== '' && !REGEX.sendAddress1.test(address1Input.value)) {

                const fieldError: any = document.getElementById(`${address1Input?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    address1Input.classList?.add('invalid-field');
                }
                else {
                    this.createErrorElement(address1Input, 'Enter a valid address.');
                }
            }
            else {
                this.hideError(address1Input?.id)
            }

        });
        address2Input?.addEventListener('input', () => {
            if (address2Input.value !== '' && !REGEX.sendAddress2.test(address2Input.value)) {

                const fieldError: any = document.getElementById(`${address2Input?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    address2Input.classList?.add('invalid-field');
                }
                else {
                    this.createErrorElement(address2Input, 'Enter a valid address.');
                }
            }
            else {
                this.hideError(address2Input?.id)
            }

        });
        cityInput?.addEventListener('input', () => {

            if (cityInput.value !== '' && !REGEX.sendCity.test(cityInput.value)) {

                const fieldError: any = document.getElementById(`${cityInput?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    cityInput.classList?.add('invalid-field');
                }
                else {
                    this.createErrorElement(cityInput, 'Enter a valid city.');
                }
            }
            else {
                this.hideError(cityInput?.id)
            }

        });
        stateSelect?.addEventListener('change', () => {

            if (stateSelect.value !== '' && !REGEX.sendName.test(stateSelect.value)) {
                const fieldError = document.getElementById(`${stateSelect?.id}-error-msg`);
                if (fieldError) {
                    fieldError.classList.remove('hidden');
                    stateSelect.classList?.add('invalid-field');
                } else {
                    this.createErrorElement(stateSelect, 'Enter a valid state.');
                }
            } else {
                this.hideError(`${stateSelect?.id}`);
            }

        });
        noteTextarea?.addEventListener('input', () => {

            noteTextarea.classList.remove('invalid-field')
            const errmsg = document.getElementById(`${noteTextarea?.id}-error-msg`)

            if (errmsg)
                errmsg?.classList.add('hidden')

        });

        customerRadio?.addEventListener('change', () => {
            customerRadio.classList.remove('invalid-field')
            const errmsg = document.getElementById(`${customerRadio?.id}-error-msg`)

            if (errmsg)
                errmsg?.remove()

            customerRadio2.classList.remove('invalid-field')
            const errmsg3 = document.getElementById(`${customerRadio2?.id}-error-msg`)

            if (errmsg3)
                errmsg3?.remove()

        });
        customerRadio2?.addEventListener('change', () => {
            customerRadio2.classList.remove('invalid-field')
            const errmsg = document.getElementById(`${customerRadio2?.id}-error-msg`)

            if (errmsg)
                errmsg?.remove()

            customerRadio.classList.remove('invalid-field')
            const errmsg3 = document.getElementById(`${customerRadio?.id}-error-msg`)

            if (errmsg3)
                errmsg3?.remove()
        });
        contEmailMethod?.addEventListener('change', () => {
            this.clearInvalidField(contEmailMethod, [contPhoneMethod, contTextMethod]);
        });
        
        contPhoneMethod?.addEventListener('change', () => {
            this.clearInvalidField(contPhoneMethod, [contEmailMethod, contTextMethod]);
        });
        
        contTextMethod?.addEventListener('change', () => {
            this.clearInvalidField(contTextMethod, [contEmailMethod, contPhoneMethod]);
        });
        
        signupRadioButton?.addEventListener('change', () => {
            this.clearInvalidField(signupRadioButton, [noThanksRadioButton]);
        });
        
        noThanksRadioButton?.addEventListener('change', () => {
            this.clearInvalidField(noThanksRadioButton, [signupRadioButton]);
        });
    }
     clearInvalidField(field: HTMLElement, relatedFields: HTMLElement[] = []) {
        field.classList.remove('invalid-field');
        const errorMessage = document.getElementById(`${field.id}-error-msg`);
        if (errorMessage) {
            errorMessage.remove();
        }
    
        relatedFields.forEach(relatedField => {
            relatedField.classList.remove('invalid-field');
            const relatedErrorMessage = document.getElementById(`${relatedField.id}-error-msg`);
            if (relatedErrorMessage) {
                relatedErrorMessage.remove();
            }
        });
    }
    protected toggleDisclaimerVisibility(countryZip: string,zipCode: string): void {
        const form = document.querySelector('.contact-info form');
        if (form) {
            const termsPolicy = document.querySelector(".sendus-form .input-label-wrap .terms-policy-text");
            if (termsPolicy) {
                const termsPolicyElement = termsPolicy as HTMLElement;
                const localisation = DomainIdentifier();
                const countryCode = getCountryCode();
                const localisedcountryCode = sessionStorage.getItem('countryCode');
                if ((countryZip === 'ca') && (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') || (countryZip === 'ca') || ((zipCode === '' || zipCode === undefined) && (localisation == 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca'))) {
                    termsPolicyElement.style.display = 'none'; // Hide for Canada ZIP codes & Canada local
                } 
                else if((countryZip === 'us' && zipCode !== '') && (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') ) {
                    termsPolicyElement.style.display = 'block';
                }
                else {
                    termsPolicyElement.style.display = 'block'; // Show for US ZIP codes
                }
            }
        }
    }
     handleFocusOut() {
        const zipCodeInput = document.getElementById('send-zip') as HTMLInputElement;
        const zipCode = zipCodeInput?.value.trim();
        DisclaimerServiceIdentifier(zipCode);
        const countryZip = !REGEX.sendCaPostalCode.test(zipCode || '') ? 'us' : 'ca';
        this.toggleDisclaimerVisibility(countryZip, zipCode);
    }

    hideError(id: any) {
        handleHideError(id);
    }


    protected createCommonState(finalResult: any) {
        const selectState = document.getElementById('send-state') as HTMLSelectElement;
        while (selectState?.firstChild) {
            selectState.removeChild(selectState.firstChild);
        }
        const option = document.createElement("option");
        const inputEl = document.getElementById('contact_us_state_placeholder') as HTMLInputElement | null;
        const dropdownPlaceholder = inputEl?.value.trim();
        option.text = dropdownPlaceholder || 'State/Province';
        option.value = '';
        selectState?.appendChild(option);
        finalResult?.forEach((item: any) => {
            const option = document.createElement("option");
            option.text = item.stateName;
            option.value = item.stateCode;
            selectState.appendChild(option);
        });

    }


    static async create() {
        const countryCode =  sessionStorage.getItem('countryCode') ?? 'us';
        const stateUsCa = document.getElementById('stateusca') as HTMLInputElement;
        const form = document.querySelector('.contact-info form button') as HTMLFormElement;
        let states = [];

        if(form) {
            if (document.getElementById('send-state')) {
                const domain = DomainIdentifier();
                if (stateUsCa?.value == "true" && domain == 'us') {
                    try {
                        const state_us = await commonStates('US');
                        const state_ca = await commonStates('CA');
                        states = [...state_us, ...state_ca];
                        states.sort((a, b) => {
                            if (a.stateName !== b.stateName) {
                                return a.stateName < b.stateName ? -1 : 1;
                            } else {
                                return 0;
                            }
                        });
                    } catch (error) {
                        console.error('Error in fetching state API data:', error);
                    }
                } else if (countryCode == 'ca' || domain == 'ca') {
                    states = await commonStates('CA');
                } else {
                    states = await commonStates('US');
                }
            }
        }

        return new FormHandler(states);
    }

    protected init(states: any) {
        this.form = document.querySelector('.contact-info form button') as HTMLFormElement;
        this.mobileNumberInput = document.getElementById('send-phone') as HTMLInputElement;

        if (this.mobileNumberInput) {
            this.mobileNumberInput.addEventListener('input', this.handleMobileInput.bind(this));
        }

        document.addEventListener('DOMContentLoaded', () => {
            const containerImages = document.querySelector('.scheduler-main')
            const isApp = window.location.pathname.includes('schedule-appointment')
            if (!containerImages && !isApp) {
                const fileInputs = document.querySelectorAll('input[type="file"]');
                fileInputs.forEach((fileInput, index) => {
                    fileInput.addEventListener('change', () => {
                        this.showFilePreview(fileInput, index)
                    }
                    );
                });

                const closeIcons = document.querySelectorAll('.icon-close')

                closeIcons.forEach((close, index) => {
                    close.addEventListener('click', this.clearPreview.bind(this, index));
                });
            }
            const localisation = DomainIdentifier();
            const countryCode = getCountryCode();
            const localisedcountryCode = sessionStorage.getItem('countryCode');
            if (localisation == 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') {
                const countryZip = (localisation === 'ca' || countryCode === 'ca') ? 'ca' : 'us';
                this.toggleDisclaimerVisibility(countryZip,'');            }
        });

        if (this.form) {
            this.createCommonState(states);
            this.form.addEventListener('click', this.handleSubmit.bind(this));
        }

        this.shortFormService?.forEach((checkbox) => {
            checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
          });

        const zipCodeInput = document.getElementById('send-zip') as HTMLInputElement;
        zipCodeInput?.addEventListener('focusout', this.handleFocusOut.bind(this));


    }

    handleCheckboxChange() {
        const serviceReminderDivs = document.querySelectorAll('.contact-info .service-reminder-main');
        if (serviceReminderDivs?.length === 0 && document.querySelector('.contact-info .service-reminder-main')) {
            console.log('Servcie Disclaimer not authored in CP');
            return;
        }
        let errorID = null;

        serviceReminderDivs.forEach(div => {
            if (div && !div.classList.contains('hidden')) {
                const checkbox = div.querySelector('input[type="checkbox"]');
                const errorMsg = div.querySelector('.error-msg');
                if (checkbox && errorMsg && checkbox instanceof HTMLInputElement && checkbox.required) {
                    checkbox.addEventListener('change', () => {
                        if (checkbox.checked) {
                            errorMsg.classList.add('hidden');
                        } else {
                            errorMsg.classList.remove('hidden');
                            errorID = errorMsg?.id;
                        }
                    });

                    if (checkbox.required && !checkbox.checked) {
                        errorID = errorMsg?.id;
                        errorMsg.classList.remove('hidden');
                    }
                }
            }
        });
        return errorID;
    }

    protected clearPreview(index: any): void {
        const previewContainer: any = document?.querySelectorAll('.file-upload img')[index];
        const uploadData: any = document?.querySelectorAll('.upload-data')[index];
        previewContainer.src = null
        const fileInputs: any = document.querySelectorAll('input[type="file"]')[index] as HTMLInputElement
        fileInputs.value = null
        previewContainer.removeAttribute('style')
        uploadData.classList.remove('active');
    }


    protected async handleSubmit(event: Event): Promise<any> {
        event.preventDefault();
        const formFields = this.getFormFields();
        const conceptId: any = document.getElementById('conceptId');
        const url = window.location.origin;
        let vendorId;

        try {

            const brandJson = getBrandJSON();
            if(brandJson === 'Error validating Location'){
                console.error("Error Determining BrandJSON path for given location")
            }
            else{
                const apiResponse = await fetch(`${url}/${brandJson}`);
                const apiData = await apiResponse.json();
                const matchingVendor = apiData.find((item: any) => item.id === conceptId?.value);
                if (matchingVendor) {
                    vendorId = matchingVendor.vendorId;
                }
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        if (this.validateForm()) {
            const formData: any = new FormData();
            startLoader();
            let host = window.location.hostname.toLowerCase();
            let IsTest;
            if (host.includes('nblysbx') || host.includes('nblydev') || host.includes('nblytest')) {
                IsTest = true;
            } else {
                IsTest = false;
            }
            this.franchiseWebLocationId = document.getElementById('weblocationId') as HTMLInputElement || document.getElementById('local_weblocationId') as HTMLInputElement
            this.isLocalized = (this.franchiseWebLocationId == undefined ? false : (this.franchiseWebLocationId?.value != '' ? true : false));
            let addressLine1 = formFields.address1 != "" ? `Address Line 1:${formFields.address1}` : "";
            let addressLine2 = formFields.address2 != "" ? `, Address line 2:${formFields.address2}` : "";
            if (addressLine1 === "" && addressLine2 === "") {
                addressLine1 = "no address collected"
            }
            let preferMethod = formFields.contactMethod ? `Prefrred Contact Method: ${formFields.contactMethod}` : ""
            const note = formFields.note ? `${formFields.note}` : "";
            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            let noteText ='';
            if(brandData.note_text_contactus_api.length > 0) {
                noteText = brandData.note_text_contactus_api;
            }
            // Handle FranchiseWebLocation ID
            // If available, set isLocalized to true as per our requirement.
            const franchiseId = await getFranchiseWebLocationIdDetails(formFields.zipCode);
            if (franchiseId) {
                this.isLocalized = true;
                this.franchiseWebLocationId = Number.parseInt(franchiseId.toString());
            } else {
                this.isLocalized = false;
                this.franchiseWebLocationId = null;
            }
            // Handle additional contact notes
            let comments:string = "";
            if(brandData?.contactUs_form_comments){
                comments = `${brandData.contactUs_form_comments}`;
            }
            if(note){
                if(comments){
                    comments +=" , ";
                }
                comments += note;
            }
            if(preferMethod){
                if(comments){
                    comments +=" , ";
                }
                comments += preferMethod;
            }

            if(noteText){
                if(comments){
                    comments +=" , ";
                }
                comments += noteText;
            }


            let requestBody: ContactUsPayloadModel = {
                "firstName": formFields.firstName,
                "address": formFields.address1,
                "address2": formFields.address2,
                "lastName": formFields.lastName,
                "zipCode": formFields.zipCode.trim(),
                "phone": formFields.phoneNumber,
                "city": formFields.city ?? "",
                "state": formFields.state ?? "",
                "email": formFields.email,
                "comments": `${comments}`,
                "signUpForUpdates": formFields?.isSignup,
                "franchiseWebLocationId": this.franchiseWebLocationId,
                "isLocalized": conceptId?.value ==="25" ? true : this.isLocalized,
                "isNewCustomer": formFields.customerType ?? '',
                "isTest": IsTest,
                "conceptId": Number.parseInt(conceptId?.value),
                "vendorId": Number.parseInt(vendorId),
            };

            try {  
                const domain = DomainIdentifier();
                const localisation = LocalizationIdentifier();
                // Default value to pass if checkbox is not found
                let checkboxId = '';
                
                if (((domain === "us" && !localisation) || (domain === "us" && localisation=="us"))) {
                    checkboxId = 'short-form-service-reminder-us';
                } else {
                    checkboxId = 'short-form-service-reminder-ca';
                }
                const contactUsForm:any = document.querySelector('.contact-info');
                this.noteWithRequestBody = disclaimerHandleCheck(false, contactUsForm, requestBody, requestBody.zipCode,checkboxId);
                requestBody = this.noteWithRequestBody;
                
                if(requestBody.city === "")
                    delete requestBody.city;
                if(requestBody.state === "")
                    delete requestBody.state;
                if(requestBody.address2 === "")
                    delete requestBody.address2;

                requestBody.comments = requestBody.comments?.replace(/^[ \t]*,/, '').trim();

    
            } catch (error) {
                console.error('An error occurred in disclaimerHandleCheck in ContactUS.ts file:', error);
            }

            const successFallbackMessage = document.querySelector('.contact-info .container .contact-block .width-60 .contact-thanku .contact-heading') as HTMLElement;

            const thankyouFallbackMessage = document.querySelector('.contact-info .container .contact-block .width-60 .contact-thanku .thanku-msg') as HTMLElement;

            //fallback message if nothing is authored from CP
            let successHeadingMessage = 'Thank you for contacting us!';
            let thankYouMessage = 'A representative from our office will get back to you shortly.';

            if(successFallbackMessage){
                if(successFallbackMessage.innerHTML)
                successHeadingMessage = successFallbackMessage.innerHTML;
            }
            if(thankyouFallbackMessage){
                if(thankyouFallbackMessage.innerHTML)
                    thankYouMessage = thankyouFallbackMessage.innerHTML;
            }

            const html = `<div class="width-60">
                <div class="contact-form-wrap contact-thanku">
                    <h2 class="contact-heading">${successHeadingMessage}</h2>
                    <p class="thanku-msg">${thankYouMessage}</p>
                </div>
            </div>`;

            const messageDiv = document.querySelector('.contact-info .container .contact-block') as HTMLFormElement;
            const formDiv = document.querySelector('.contact-info .container .contact-block .width-60') as HTMLFormElement;

            contactUsPostCallWrapper(apiConfig.CONTACT_US_SEND, requestBody)
                .then((response: any) => {
                    requestEstimate('contact_us','long-form','success','');
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'success'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                    storeBookingApiPayload(requestBody,response);
                    stopLoader()
                    formDiv.remove()
                    messageDiv?.insertAdjacentHTML('afterbegin', html);
                    this.insertAfterUrl();
                    document.querySelectorAll('.contact-thanku')?.forEach((el) => el.scrollIntoView(false));
                })
                .catch((err) => {
                    requestEstimate('contact_us','long-form','failure','');
                    stopLoader();
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'failure'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                });
        } else {
            stopLoader()
        }
    }
    protected insertAfterUrl(): any {
        const refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '#thank-you';
        window.history.pushState({ path: refresh }, '', refresh);
    }
    
    protected getFormFields(){
        const fields: any = {
            firstName: (document.getElementById('send-name') as HTMLInputElement)?.value ?? "",
            lastName: (document.getElementById('send-lname') as HTMLInputElement)?.value ?? "",
            zipCode: (document.getElementById('send-zip') as HTMLInputElement)?.value ?? "",
            phoneNumber: (document.getElementById('send-phone') as HTMLInputElement)?.value ?? "",
            email: (document.getElementById('send-email') as HTMLInputElement)?.value ?? "",
            customerType: this.getSelectedRatio(document.getElementsByName('inline-radio-cust')),
            contactMethod: this.getSelectedRatio(document.getElementsByName('inline-radio-method')),
            address1: (document.getElementById('send-address1') as HTMLInputElement)?.value ?? "",
            address2: (document.getElementById('send-address2') as HTMLInputElement)?.value ?? "",
            city: (document.getElementById('send-city') as HTMLInputElement)?.value ?? "",
            state: (document.getElementById('send-state') as HTMLSelectElement)?.value ?? "",
            note: (document.getElementById('send-note') as HTMLTextAreaElement)?.value ?? "",
        };
    
        if(document.querySelector('input[name="inline-radio-tips"]')) {
            fields['isSignup'] = (document.querySelector('input[name="inline-radio-tips"]') as HTMLInputElement)?.checked ?? "";
        }
    
        return fields;
    }
    

    protected getSelectedRatio(node: any): string | null {
        const radioButtons = node;
        for (const radioButton of radioButtons) {
            if ((radioButton as HTMLInputElement).checked) {
                const labelElement = document.querySelector(`[for="${radioButton.id}"]`) as HTMLElement;
                const label = labelElement.innerText;
                return label;
            }
        }
        return null;
    }

    protected getSelectedFiles(): File[] {
        const fileInputs = document.querySelectorAll('input[type="file"]');
        const selectedFiles: File[] = [];
        fileInputs.forEach((input: any) => {
            if (input.files && input.files.length > 0) {
                selectedFiles.push(input.files[0]);
            }
        });
        return selectedFiles;
    }

    protected handleMobileInput(e: Event): void {
        e.preventDefault();
        const reg = REGEX.mobileNumberRegex;
        const val = this.mobileNumberInput?.value;
        const phoneMatch = val?.replace(/\D/g, '').match(reg);
 

        let formattedVal = '';

        if (phoneMatch) {
            const areaCode = phoneMatch[1];
            const mainNumber = phoneMatch[2];
            const optionalDashWithPhoneNumbers = phoneMatch[3] ? '-' + phoneMatch[3] : '';
            formattedVal = `(${areaCode}) ${mainNumber}${optionalDashWithPhoneNumbers}`;
        }
        if (this.mobileNumberInput && this.mobileNumberInput.value != '' && this.mobileNumberInput.value.length < 14 && formattedVal.length < 14) {
            const getErrMsg = (document.getElementById(`send-phone-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-phone-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid phone format.'
            }
            this.mobileNumberInput.classList.add("invalid-field");
        }else {
            this.hideError(`${this.mobileNumberInput?.id}`); 
        }

        if (phoneMatch) {
            this.mobileNumberInput!.value = !phoneMatch[2] ? phoneMatch[1] : `(${phoneMatch[1]}) ${phoneMatch[2]}${phoneMatch[3] ? '-' + phoneMatch[3] : ''}`;
        }
    }

    protected showFilePreview(fileInput: any, index: number): void {
      handleFilePreview(fileInput, index, FilesUrl);
    }


    protected validateForm(): boolean {
        document.querySelectorAll('.invalid-field').forEach(e => e.classList.remove('invalid-field'));
        const errors: any = {};
        const firstNameInput = document.getElementById('send-name') as HTMLInputElement;
        const lastNameInput = document.getElementById('send-lname') as HTMLInputElement;
        const zipCodeInput = document.getElementById('send-zip') as HTMLInputElement;
        const phoneNumberInput = document.getElementById('send-phone') as HTMLInputElement;
        const emailInput = document.getElementById('send-email') as HTMLInputElement;
        const address1Input = document.getElementById('send-address1') as HTMLInputElement;
        const address2Input = document.getElementById('send-address2') as HTMLInputElement;
        const cityInput = document.getElementById('send-city') as HTMLInputElement;
        const stateSelect = document.getElementById('send-state') as HTMLSelectElement;
        const noteTextarea = document.getElementById('send-note') as HTMLTextAreaElement;

        const customerRadio = document.getElementById('inline-radio-1') as HTMLInputElement;
        const customerRadio2 = document.getElementById('inline-radio-2') as HTMLInputElement;
        const contPhoneMethod = document.getElementById('inline-radio-3') as HTMLInputElement;
        const contEmailMethod = document.getElementById('inline-radio-4') as HTMLInputElement;
        const contTextMethod = document.getElementById('inline-radio-5') as HTMLInputElement;
        const signupRadioButton = document.getElementById('inline-2-radio-3') as HTMLInputElement;
        const noThanksRadioButton = document.getElementById('inline-2-radio-4') as HTMLInputElement;

        if(firstNameInput){
            const fieldError = firstNameInput?.parentElement?.querySelector('#send-name-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent :  'Enter a valid First Name';
            if (firstNameInput.required && (firstNameInput.value === '' || !REGEX.sendName.test(firstNameInput.value))) {
                errors['send-name'] = authoredMessage;
            }
        }

        if(lastNameInput){
            const fieldError = lastNameInput?.parentElement?.querySelector('#send-lname-error-msg');
            const authoredMessage =  fieldError ? fieldError.textContent : 'Enter a valid Last Name';
            if (lastNameInput.required && (lastNameInput.value === '' || !REGEX.sendLname.test(lastNameInput.value))) {
                errors['send-lname'] = authoredMessage;
            }
        }

        if(zipCodeInput){
            const fieldError = zipCodeInput?.parentElement?.querySelector('#send-zip-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid ZIP Code';
            if (zipCodeInput.required && (zipCodeInput.value === '' || !REGEX.sendZip.test(zipCodeInput.value))) {
                errors['send-zip'] = authoredMessage;
            }
        }

        if(phoneNumberInput){
            const fieldError = phoneNumberInput?.parentElement?.querySelector('#send-phone-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid Phone Number';
            if (phoneNumberInput.required && (phoneNumberInput.value === '' || phoneNumberInput.value?.length < 14)) {
                errors['send-phone'] = authoredMessage;
            }
        }

        if(stateSelect){
            const fieldError = stateSelect?.parentElement?.querySelector('#send-state-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid State';
            if (stateSelect.required && stateSelect.value === '') {
                errors['send-state'] = authoredMessage;
            }
        }
        
        if(address1Input){
            const fieldError = stateSelect?.parentElement?.querySelector('#send-address1-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid Address';
            if (address1Input.required && (address1Input.value === '' || !REGEX.sendAddress1.test(address1Input.value))) {
                errors['send-address1'] = authoredMessage;
            }
        }

        if(address2Input){
            const fieldError = stateSelect?.parentElement?.querySelector('#send-address2-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid Address';
            if (address2Input.required && (address2Input.value === '' || !REGEX.sendAddress2.test(address2Input.value))) {
                errors['send-address2'] = authoredMessage;
            }
        }


        if(noteTextarea){
            const fieldError = noteTextarea?.parentElement?.querySelector('#send-note-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid comment'
            if (noteTextarea.required && noteTextarea.value === '') {
                errors['send-note'] = authoredMessage;
            }
        }

        if(emailInput){
            const fieldError = emailInput?.parentElement?.querySelector('#send-email-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid Email';
            if (emailInput.required && (emailInput.value === '' || !REGEX.sendEmail.test(emailInput.value))) {
                errors['send-email'] = authoredMessage;
            }
        }

        if(cityInput){
            const fieldError = cityInput?.parentElement?.querySelector('#send-city-error-msg');
            const authoredMessage = fieldError ? fieldError.textContent : 'Enter a valid City';
            if (cityInput.required && (cityInput.value === '' || !REGEX.sendCity.test(cityInput.value))) {
                errors['send-city'] = authoredMessage;
            }
        }

        if(customerRadio && customerRadio2){
            if (customerRadio.required && customerRadio2.required && (!customerRadio2.checked && !customerRadio.checked)) {
                errors['inline-radio-1'] = '';
            }
        }
        if(contPhoneMethod && contEmailMethod && contTextMethod){
            if (contPhoneMethod.required && contEmailMethod.required && contTextMethod.required &&(!contPhoneMethod.checked && !contEmailMethod.checked && !contTextMethod.checked)) {
                errors['inline-radio-3'] = '';
            }
        }
        if(signupRadioButton && noThanksRadioButton){
            if (signupRadioButton.required && noThanksRadioButton.required && (!signupRadioButton.checked && !noThanksRadioButton.checked)) {
                errors['inline-2-radio-3'] = '';
            }
        }

        const errorIdChekboxSpan = this.handleCheckboxChange();

        if(errorIdChekboxSpan){
            errors[errorIdChekboxSpan] = '';
        }

        Object.keys(errors).forEach((fieldId, index) => {
            if (fieldId == 'inline-radio-1' || fieldId == 'inline-radio-2' || fieldId == 'inline-radio-3' || fieldId == 'inline-radio-4' || fieldId == 'inline-radio-5' || fieldId == 'inline-2-radio-3' || fieldId == 'inline-2-radio-4') {
                const field: any = document.querySelector(`#${fieldId}`)?.closest('.radio-btn-wrapper');
                if(field?.parentNode) {
                    if (fieldId == 'inline-radio-1' || fieldId == 'inline-radio-2'){
                        customerRadio.classList.add("invalid-field");
                        customerRadio2.classList.add("invalid-field");
                    } else if (fieldId == 'inline-radio-3' || fieldId == 'inline-radio-4' || fieldId == 'inline-radio-5'){
                        contPhoneMethod.classList.add("invalid-field");
                        contEmailMethod.classList.add("invalid-field");
                        contTextMethod.classList.add("invalid-field");
                    } else{
                        signupRadioButton.classList.add("invalid-field");
                        noThanksRadioButton.classList.add("invalid-field");
                    }

                    const fieldError = field.parentNode.querySelector(`#${fieldId}-error-msg`);
                    if(fieldError) {
                        if (fieldError?.classList.contains('hidden')) {
                            fieldError.classList.remove('hidden')
                        }
                    } else {
                        const errorMessage = errors[fieldId] || "This field is mandatory.";
                        const errorElement = document.createElement('span');
                        errorElement.className = 'error-msg';
                        errorElement.id = `${fieldId}-error-msg`;
                        errorElement.textContent = errorMessage;
                        field.classList.add("invalid-field");
                        field.after(errorElement);
                    }
                }
            }
            else {

                const field: any = document.getElementById(fieldId);
                let fieldError: any = document.getElementById(`${fieldId}-error-msg`);

                if (field?.parentNode) {

                    const errorMessage = errors[fieldId] || "This field is mandatory.";
                    field.classList.add("invalid-field");

                    if (!fieldError) {
                        const errorElement = document.createElement('span');
                        errorElement.className = 'error-msg';
                        errorElement.id = `${fieldId}-error-msg`;
                        errorElement.textContent = errorMessage;
                        field.parentNode.appendChild(errorElement);
                        fieldError = errorElement;
                    }

                    if (fieldError?.classList.contains('hidden'))
                        fieldError.classList.remove('hidden')
                }

                if (index == 0 && field) {
                    field.focus()
                }
            }
        });

        return Object.keys(errors).length === 0;
    }

    protected createErrorElement(inputField: HTMLInputElement | HTMLSelectElement, errorMessage: string): void {
        const errorElement = document.createElement('span');
        errorElement.className = 'error-msg';
        errorElement.id = `${inputField.id}-error-msg`;
        errorElement.textContent = errorMessage;
        inputField.classList?.add('invalid-field');
        if (inputField?.parentNode) {
            inputField.parentNode.appendChild(errorElement);
        }
    }
}

(async () => {
    // Check if DOM loader will handle this
    if (!(globalThis as any).__ContactUsFormHandlerDOMLoader && !(globalThis as any).__ContactUsFormHandlerCreated && !document.getElementById('ask-question-form')) {
        (globalThis as any).__ContactUsFormHandlerDOMLoader = true;
        (globalThis as any).__ContactUsFormHandlerCreated = true;
        await FormHandler.create();
    }
})();
